import {Pipe, PipeTransform} from '@angular/core';
import {CardDto} from '../../../core/services/GPRMV1Service.Generated';

@Pipe({
    name: 'elementEntityPipe',
    standalone: false
})
export class ElementEntityPipe implements PipeTransform {
  transform(elementEntityList: CardDto[], entityTypeId: number ) {
    if ( entityTypeId && entityTypeId > 0) {
      return (elementEntityList || []).filter(element => element.entityTypeId === entityTypeId);
    } else {
      throw Error('Entity is undefined');
    }
  }
}
